import { type IbHttpClient } from '@frontends/feature-ib';
import { type AxiosInstance } from 'axios';
import { axiosIb } from '@/lib/axios';

export const createIbHttpClient = (instance: AxiosInstance): IbHttpClient => ({
  request: ({ method, path, params, body, signal }) =>
    instance.request({ method, url: path, params, data: body, signal }).then((response) => response.data),
});

export const ibHttpClient = createIbHttpClient(axiosIb);
